<template>
    <div class="content-wrapper">
        <div class="d-flex align-items-center justify-content-between">
            <app-breadcrumb :page-title="$t('duty_station')"/>

            <div>
                <button class="btn btn-with-shadow btn-info mb-4"
                        type="button"
                        @click="openModal()">
                    <app-icon class="size-20 mr-2" name="plus"/>
                    {{ $t('add_duty_station') }}
                </button>
            </div>
        </div>

        <app-table :id="tableId" :options="options" @action="triggerActions"/>

        <duty-station-create-edit-modal
            v-if="isModalActive"
            v-model="isModalActive"
            :selected-url="selectedUrl"
            @close="isModalActive = false"
        />

        <app-confirmation-modal
            v-if="confirmationModalActive"
            modal-id="app-confirmation-modal"
            @confirmed="confirmed('break-time-table')"
            @cancelled="cancelled"
            icon="trash-2"
            sub-title=""
            :message="message"
            modal-class="danger"
        />
    </div>
</template>

<script>

import DatatableHelperMixin from "../../../../common/Mixin/Global/DatatableHelperMixin";
import {DISTRICT, DUTY_STATION} from "../../../../common/Config/apiUrl";
import {urlGenerator} from "../../../../common/Helper/AxiosHelper";
import DutyStationCreateEditModal from "./DutyStationCreateEditModal.vue";

export default {
    name: "DutyStation",
    mixins: [DatatableHelperMixin],
    components: {DutyStationCreateEditModal},
    data() {
        return {
            urlGenerator,
            isModalActive: false,
            selectedUrl: '',
            tableId: 'duty-station-table',
            message: '',
            options: {
                url: DUTY_STATION,
                name: 'duty-station-table',
                columns: [
                    {
                        title: this.$t('name'),
                        type: 'text',
                        key: 'name',
                    },
                    {
                        title: this.$t('district'),
                        type: 'object',
                        key: 'district',
                        modifier: (value) => {
                            return value.name
                        }
                    },
                    {
                        title: this.$t('actions'),
                        type: 'action'
                    }
                ],
                filters: [],
                actions: [
                    {
                        title: this.$t('edit'),
                        name: 'edit',
                        icon: 'edit'
                    },
                    {
                        title: this.$t('delete'),
                        icon: 'trash-2',
                        message: this.$t('you_are_going_to_delete_message', {resource: this.$t('break_time')}),
                        name: 'delete',
                        modifier: row => true
                    }
                ],
                rowLimit: 10,
                orderBy: 'desc',
                responsive: true,
                showHeader: true,
                showFilter: true,
                showSearch: false,
                showAction: true,
                tableShadow: true,
                actionType: 'default',
                datatableWrapper: true,
                paginationType: 'pagination'
            },
        }
    },
    methods: {
        openModal() {
            this.selectedUrl = '';
            this.isModalActive = true;
        },
        triggerActions(row, action, active) {
            if (action.name === 'edit') {
                this.selectedUrl = `${DUTY_STATION}/${row.id}`;
                this.isModalActive = true;
            } else if (action.name === 'delete') {
                this.delete_url = `${DUTY_STATION}/${row.id}`;
                this.message = action.message;
                this.confirmationModalActive = true;
            }
        }
    }
}
</script>